var _style, _path, _circle, _rect, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _polygon, _circle3, _circle4, _polygon2, _circle5, _circle6, _circle7, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path15, _path16, _rect9, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadyDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4e67b16-eb74-42a6-b922-9d4e1a643c89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1036 784.4",
    style: {
      enableBackground: "new 0 0 1036 784.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#38383D;}\n\t.st1{fill:#3F3D56;}\n\t.st2{fill:#2F2E41;}\n\t.st3{fill:#FFB9B9;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{fill:#575A89;}\n\t.st6{fill:#797BF2;}\n\t.st7{opacity:0.3;fill:#797BF2;enable-background:new    ;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "result") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M678.4,0L489.6,210.7c40.8,31.7,48.3,90.5,16.6,131.3s-90.5,48.3-131.3,16.6c-3.5-2.7-6.8-5.7-9.9-8.8 L102,643.3c75.8,58.9,169.2,90.9,265.2,90.7c239.1,0,433-193.9,433-433C800.3,188.7,756.6,80.7,678.4,0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 435.4,
    cy: 289.5,
    r: 56.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95.6,
    y: 394.4,
    className: "st1",
    width: 617.2,
    height: 388.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M773.4,201.6c0,0-39.8-1.6-40.9,39.2s0,75.8,0,75.8h79.6V243C812.2,243,810.5,204.3,773.4,201.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M757.9,274.4c0,0,2.4,26.8-5.5,29.1s3.1,36.2,3.1,36.2l31.5,7.1l18.1-36.2l-7.9-10.2c0,0-13.4-18.1-7.1-30.7 S757.9,274.4,757.9,274.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M757.9,274.4c0,0,2.4,26.8-5.5,29.1s3.1,36.2,3.1,36.2l31.5,7.1l18.1-36.2l-7.9-10.2c0,0-13.4-18.1-7.1-30.7 S757.9,274.4,757.9,274.4z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 768.9,
    cy: 256.3,
    r: 30.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M649.3,361.8c0,0-18.9,14.2-13.4,25.2s22,48.8,22,48.8s3.1,29.1,16.5,27.6s0-30.7,0-30.7l-16.5-44.9l5.5-8.7 L649.3,361.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M904.4,366.5c0,0,21.3,16.5,8.7,22.8s-66.1,36.2-66.1,36.2s-32.3,24.4-36.2,5.5s21.3-18.1,21.3-18.1 s50.4-30.7,52.7-37S904.4,366.5,904.4,366.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M717,474.4c0,0-10.2,55.9-4.7,87.4c3.2,19.6,2.7,39.6-1.6,59l30.7,3.1c0,0,19.7-116.5,30.7-115.7 s34.6,117.3,34.6,117.3l33.1-4.7c0,0-10.2-52-5.5-67.7s1.6-72.4-10.2-78.7S717,474.4,717,474.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M744.5,620.8c0,0-35.4-11.8-38.6-3.1s-2.4,105.5-1.6,111.8s3.1,3.1,0.8,6.3s-2.4-3.9-1.6,4.7s1.6,10.2,1.6,10.2 s-14.2,33.1,11,32.3s13.4-24.4,13.4-24.4s3.9-7.1,1.6-11s-3.1-10.2,0-13.4s-3.1-9.4-3.9-11.8s-3.1-1.6,3.1-9.4s3.1-11.8,2.4-14.2 s5.5-16.5,5.5-16.5L744.5,620.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M804.4,620.8c0,0,35.4-11.8,38.6-3.1s2.4,105.5,1.6,111.8s-3.1,3.1-0.8,6.3s2.4-3.9,1.6,4.7s-1.6,10.2-1.6,10.2 s14.2,33.1-11,32.3s-13.4-24.4-13.4-24.4s-3.9-7.1-1.6-11s3.1-10.2,0-13.4s3.1-9.4,3.9-11.8s3.1-1.6-3.1-9.4s-3.1-11.8-2.4-14.2 s-5.5-16.5-5.5-16.5L804.4,620.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M770.5,328.7c0,0-5.5-16.5-8.7-19.7s-5.2-11.3-5.2-11.3s-17.6,6.6-22.4,8.1s-20.5,1.6-20.5,3.9v50.4 c0,0-1.6,10.2,1.6,36.2s12.6,41.7,1.6,52.7s-1.6,37.8,3.9,42.5s112.6,29.1,113.4-28.3c0,0-26-45.7-15-60.6s20.5-40.2,20.5-40.2 v-50.4c0,0-17.3-5.5-22.8-6.3s-18.9-15.7-20.5-15s-4.6,0-4.6,0l-0.1,11.1L770.5,328.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M724.8,313.8l-11-3.9c0,0-13.4,7.1-13.4,8.7s-7.9,8.7-11.8,11.8s-15,3.9-15,5.5s-34.6,26.8-31.5,30.7 s13.4,18.1,18.9,18.1s18.9-14.2,21.3-15s26.8-15.7,34.6-13.4S724.8,313.8,724.8,313.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M824.8,315.4l15-3.1c0,0,28.3,21.3,29.1,22s44.9,29.1,42.5,34.6s-27.6,13.4-33.9,11s-33.1-22-43.3-19.7 S824.8,315.4,824.8,315.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M801.6,246.5c3.7-15.7,2.2-19.9,2.2-19.9L756,214.8l-16.7,16.1v16.7l1.7,5.2c0,0,6.9-5.2,4.2-12.7 C745.2,240,798.9,257.8,801.6,246.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M802.2,237.7l-4.5,4.9c7.1,0.1-2.4,57.6,0.8,66.9l11.8,0.3v-76.6L802.2,237.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 739.4,
    cy: 251.6,
    rx: 2.4,
    ry: 5.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 800,
    cy: 251.6,
    rx: 2.4,
    ry: 5.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "372.7,694.8 371.3,693.3 432.1,632.5 378.3,578.8 379.7,577.3 434.9,632.5 "
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 430,
    cy: 633,
    r: 21
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 375,
    cy: 694,
    r: 21
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "376.7,578.8 375.3,577.3 436.1,516.5 382.3,462.8 383.7,461.3 438.9,516.5 "
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 383,
    cy: 462,
    r: 21
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 434,
    cy: 517,
    r: 21
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 379,
    cy: 578,
    r: 21
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123,
    y: 419,
    className: "st7",
    width: 104,
    height: 19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 634,
    className: "st7",
    width: 104,
    height: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 649,
    className: "st7",
    width: 104,
    height: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 664,
    className: "st7",
    width: 104,
    height: 5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 679,
    className: "st7",
    width: 104,
    height: 5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 694,
    className: "st7",
    width: 104,
    height: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 709,
    className: "st7",
    width: 104,
    height: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.8,743c6.9,25.6,30.6,41.4,30.6,41.4s12.5-25.6,5.6-51.2s-30.6-41.4-30.6-41.4S59.8,717.4,66.8,743z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M76.9,737.5c19,18.5,21.3,46.9,21.3,46.9s-28.4-1.6-47.4-20s-21.3-46.9-21.3-46.9S57.9,719,76.9,737.5z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 782,
    className: "st1",
    width: 1036,
    height: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M978.5,720.5c0-9.1-5.6-17.2-14-20.5c11.3-4.4,16.9-17.1,12.5-28.5c-4.4-11.3-17.1-16.9-28.5-12.5 c-11.3,4.4-16.9,17.1-12.5,28.5c2.2,5.8,6.8,10.3,12.5,12.5c-11.3,4.4-16.9,17.1-12.5,28.5c2.2,5.8,6.8,10.3,12.5,12.5 c-11.3,4.4-16.9,17.1-12.5,28.5c4.4,11.3,17.1,16.9,28.5,12.5c11.3-4.4,16.9-17.1,12.5-28.5c-2.2-5.8-6.8-10.3-12.5-12.5 C972.9,737.7,978.5,729.6,978.5,720.5z M936.5,679.5c0-11,8.9-20,20-20c11,0,20,8.9,20,20c0,9.3-6.4,17.4-15.5,19.5 c-3-0.6-6-0.6-9,0C942.9,696.9,936.5,688.8,936.5,679.5z M976.5,761.5c0,11-8.9,20-20,20c-11,0-20-8.9-20-20 c0-9.3,6.4-17.4,15.5-19.5c3,0.6,6,0.6,9,0C970.1,744.2,976.5,752.2,976.5,761.5z M961,740c-3-0.6-6-0.6-9,0 c-10.8-2.5-17.5-13.2-15-24c1.7-7.4,7.5-13.3,15-15c3,0.6,6,0.6,9,0c10.8,2.5,17.5,13.2,15,24C974.3,732.5,968.5,738.3,961,740z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.5,356.5c-12.2,0-22-9.8-22-22s9.8-22,22-22s22,9.8,22,22C128.5,346.7,118.6,356.5,106.5,356.5z  M106.5,314.5c-11,0-20,9-20,20s9,20,20,20s20-9,20-20C126.5,323.5,117.5,314.5,106.5,314.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.5,137.5c-12.2,0-22-9.8-22-22s9.8-22,22-22s22,9.8,22,22l0,0C595.5,127.7,585.6,137.5,573.5,137.5z  M573.5,95.5c-11,0-20,9-20,20s9,20,20,20s20-9,20-20C593.5,104.5,584.5,95.5,573.5,95.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyDark);
export default __webpack_public_path__ + "static/media/ready-dark.c2cc51bea747d6803de515a2714c22ca.svg";
export { ForwardRef as ReactComponent };